import axios from "axios";
import { PDC_EMBED_STORAGE_KEY } from "@/utils/pdcEmbed";
import { getPdcApiBaseUrl } from "@/utils/pdc-external-course-list";

/**
 * baseURL on each request avoids a stale/empty host from module init (HMR / import order).
 */
export const pdcExternalApi = axios.create({
  timeout: 15000,
});

pdcExternalApi.interceptors.request.use((config) => {
  const apiBase = getPdcApiBaseUrl();
  if (apiBase) {
    config.baseURL = apiBase;
  }

  const key =
    typeof localStorage !== "undefined"
      ? localStorage.getItem(PDC_EMBED_STORAGE_KEY)
      : null;
  if (config.headers && key) {
    config.headers["x-api-key"] = key;
  }
  return config;
});
